import script from "./associateReports.vue?vue&type=script&setup=true&lang=js"
export * from "./associateReports.vue?vue&type=script&setup=true&lang=js"

import "./associateReports.vue?vue&type=style&index=0&id=36302ca3&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36302ca3"]])

export default __exports__